import { useMutation } from "@tanstack/react-query";
import { searchReversedGeoLocationApiAction } from "../actions/actions";

export const useReversedGeolocationMutation = () => {
  return useMutation({
    mutationFn: ({ lat, lon }: { lat: number; lon: number }) =>
      searchReversedGeoLocationApiAction({ lat, lon }),
  });
};
